@let routeContextTitle = (routeData$ | async)?.['title'];
@let routeContextTitleMobile = (routeData$ | async)?.['titleMobile'];
<span class="heading-subtitle">{{ isMobile() ? routeContextTitleMobile : routeContextTitle }}</span>
